module.exports = __webpack_public_path__ + "static/media/comp-mob2.615bb0b5.png";